import { render, staticRenderFns } from "./PatientDepositPanel.vue?vue&type=template&id=2d47d438&scoped=true"
import script from "./PatientDepositPanel.vue?vue&type=script&lang=js"
export * from "./PatientDepositPanel.vue?vue&type=script&lang=js"
import style0 from "./PatientDepositPanel.vue?vue&type=style&index=0&id=2d47d438&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47d438",
  null
  
)

export default component.exports